import React from "react";
import { Link } from "react-router-dom";
import "../styles/RoadmapPage.css";

function RoadmapPage() {
  // Updated Roadmap features data
  const roadmapFeatures = [
    {
      id: 1,
      title: "Multi-Chain Support",
      description: "Expand beyond Solana to integrate with Ethereum, Arbitrum, and other leading blockchains for a comprehensive cross-chain experience.",
      phase: "Blockchain Expansion",
      icon: "layers"
    },
    {
      id: 9,
      title: "Social Trading Copy Mechanism",
      description: "Implement a revolutionary auto-trade feature where users can directly mirror top-performing traders' portfolios with customizable risk settings and performance-based rewards.",
      phase: "Trading Innovation",
      icon: "copy"
    },
    {
      id: 2,
      title: "Enhanced Data Privacy",
      description: "Implementing advanced encryption protocols and zero-knowledge proofs to further secure user data and communications.",
      phase: "Security Fortification",
      icon: "shield"
    },
    {
      id: 3,
      title: "Social Media Integration",
      description: "Seamless Twitter and TikTok connectivity, allowing users to cross-post content, share trading insights, and expand their social trading network.",
      phase: "Social Connectivity",
      icon: "share-2"
    },
    {
      id: 4,
      title: "Native Content Platform",
      description: "Build your own trading community directly on Solcialize. Create posts, share analysis, comment on other traders' insights, and engage in real-time discussions.",
      phase: "Community Building",
      icon: "message-circle"
    },
    {
      id: 5,
      title: "AI-Powered Social Recommendations",
      description: "Smart algorithms to recommend connections based on trading style, token preferences, on-chain behavior, and interaction patterns.",
      phase: "Intelligent Networking",
      icon: "user-plus"
    },
    {
      id: 6,
      title: "Advanced Analytics Dashboard 2.0",
      description: "Next-generation insights with machine learning-powered predictive analytics, comprehensive network performance metrics, and interactive visualization tools.",
      phase: "Data Intelligence",
      icon: "pie-chart"
    },
    {
      id: 7,
      title: "Interactive Character Profiles",
      description: "Customizable 3D avatars and animated trading personas that reflect your trading style, achievements, and personality.",
      phase: "User Experience Enhancement",
      icon: "users"
    },
    {
      id: 8,
      title: "Gamified Trading Experience",
      description: "Introduce achievement systems, trading challenges, and rewards to make social trading more engaging and fun.",
      phase: "Engagement Mechanics",
      icon: "award"
    }
  ];

  // Helper function to render icon based on name
  const renderIcon = (iconName) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {iconName === "layers" && (
          <>
            <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
            <polyline points="2 17 12 22 22 17"></polyline>
            <polyline points="2 12 12 17 22 12"></polyline>
          </>
        )}
        {iconName === "shield" && (
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        )}
        {iconName === "share-2" && (
          <>
            <circle cx="18" cy="5" r="3"></circle>
            <circle cx="6" cy="12" r="3"></circle>
            <circle cx="18" cy="19" r="3"></circle>
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
          </>
        )}
        {iconName === "message-circle" && (
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
        )}
        {iconName === "user-plus" && (
          <>
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="8.5" cy="7" r="4"></circle>
            <line x1="20" y1="8" x2="20" y2="14"></line>
            <line x1="23" y1="11" x2="17" y2="11"></line>
          </>
        )}
        {iconName === "pie-chart" && (
          <>
            <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
            <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
          </>
        )}
        {iconName === "users" && (
          <>
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </>
        )}
        {iconName === "award" && (
          <>
            <circle cx="12" cy="8" r="7"></circle>
            <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
          </>
        )}
        {iconName === "copy" && (
          <>
            <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
            <path d="M8 18V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1z"></path>
          </>
        )}
      </svg>
    );
  };

  return (
    <div className="roadmap-page">
      <header className="roadmap-header">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-6">
            <Link to="/" className="font-bold text-xl tracking-tight bg-gradient-to-r from-[#FF4FBF] via-[#9D4EDD] to-[#5B5FFF] text-transparent bg-clip-text">
              Solcialize
            </Link>
            <nav className="flex items-center gap-6">
              <Link to="/" className="roadmap-nav-link">Home</Link>
            </nav>
          </div>
        </div>
      </header>

      <main className="roadmap-main">
        <div className="container mx-auto px-4 py-12">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#FF4FBF] via-[#9D4EDD] to-[#5B5FFF] text-transparent bg-clip-text">
              Our Roadmap
            </h1>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              Charting the future of Solcialize with groundbreaking features to revolutionize social trading.
            </p>
          </div>

          <div className="roadmap-container">
            <div className="roadmap-features">
              {roadmapFeatures.map((feature) => (
                <div key={feature.id} className={`roadmap-feature-card feature-${feature.id}`}>
                  <div className={`feature-icon phase-${feature.phase.replace(/\s+/g, '-').toLowerCase()}`}>
                    {renderIcon(feature.icon)}
                  </div>
                  <div className="feature-content">
                    <div className="feature-label">{feature.phase}</div>
                    <h3 className="feature-title">{feature.title}</h3>
                    <p className="feature-description">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      <footer className="roadmap-footer">
        <div className="container mx-auto px-4 py-8">
          <p className="text-center text-gray-500">
            © {new Date().getFullYear()} Solcialize. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default RoadmapPage;